<template>
  <b-modal ref="modal" :hide-footer="true">
    <template slot="modal-header">
      <h1>Select Field</h1>

      <div>
        <Button :empty="true" class="close-popup" @click.prevent="hide">{{ Translations.buttons.cancel }}</Button>
        <Button :empty="false" :noBorder="true" class="validate" @click.prevent="updateField">Done</Button>
      </div>
    </template>

    <template>
      <div class="flex-container">
        <div class="search-result">
          <div v-for="field in sortedFields" :key="`modal-field-${field.name}`" v-on:click="changeField(field)" class="label-container">
            <i :class="`far fa${field.name === currentField.name ? '-check' : ''}-square`"></i>
            <span class="name"><strong>{{field.label}}</strong></span>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import Bootstrap from 'bootstrap-vue';
  import Button from '../common/Button';
  import Constants from '../../store/constants';
  import Translations from '../../store/translations';

  export default {
    name: 'SelectorField',
    components: { Button },
    props: ['currentFields'],
    computed: {
      Constants: () => Constants,
      Translations: () => Translations,
      fields() {
        if (!this.currentFields || this.currentFields.length === 0) {
          if(this.$route.name === 'SmartBoxFilters'){
            return Constants.fields.filter(e => e.name !== 'sources');
          }
          return Constants.fields;
        }

        const fields = Constants.fields.filter(field => {
          let notCurrent = true;

          this.currentFields.map(f => {
            if (f === field.name) {
              notCurrent = false;
            }

            return true;
          })

          return notCurrent;
        });

        // remove sources for smartBox filters
        if(this.$route.name === 'SmartBoxFilters'){
          return fields.filter(e => e.name !== 'sources');
        }
        return fields;
      },
      sortedFields () {
        return this.fields.slice().sort((a, b) => {
          const labelA = a.label.toLowerCase()
          const labelB = b.label.toLowerCase()
          if (labelA < labelB) {
            return -1
          } else if (labelA > labelB) {
            return 1
          }

          return 0
        })
        return 0
      }
    },
    data() {
      return {
        currentField: {}
      }
    },
    methods: {
      show(field) {
        this.$refs.modal.show();
      },
      hide() {
        this.$refs.modal.hide();
      },
      changeField(field) {
        this.currentField = field;
      },
      updateField() {
        this.$emit('newValue', this.currentField);
        this.hide();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .label-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    cursor: pointer;
    border-radius: 4px;
    padding: 7px;
  }

  .no-result-container header {
      padding: 20px 25px;
  }

  .name {
    width: 100%;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 1em;
    transition: color .2s ease-in-out;
  }

  .modal .modal-content div.flex-container {
    display: flex;
    flex-direction: column;
    margin: -15px;
    width: calc(100% + 30px);
    height: calc(100% + 30px);
  }

  .far.fa-eye {
    color: white;
  }

  .far.fa-eye-slash {
    color: #FF2213;
  }

  .search-result {
    padding: 15px;
    height: auto;
    overflow: auto;
    max-height: calc(100vh - 200px);
  }
</style>
